import { Field } from 'react-final-form'

import FormItem from 'common/components/formItem'
import IconTitleGroup from 'common/components/iconTitleGroup'
import Textarea from 'common/components/textarea/Textarea'

const MAX_NAME_LENGTH = 250

const ruleInstructionValidation = (value: string) => {
  if (!value) {
    return 'Rule is required'
  } else if (value.length > MAX_NAME_LENGTH) {
    return `Rule must be ${MAX_NAME_LENGTH} characters or less`
  }

  return undefined
}

const RuleInstructionField = () => {
  return (
    <>
      <IconTitleGroup title="Details" className="mb-4" />
      <Field<string>
        name="rule"
        validate={ruleInstructionValidation}
        render={({ input, meta }) => (
          <FormItem
            label="Rule instruction"
            htmlFor="rule"
            error={meta.touched ? meta.error : undefined}
          >
            <Textarea
              id="rule"
              placeholder='Define your rule - e.g. "Do not say or imply that our products provide health benefits or improvements to health, wellness or wellbeing."'
              className="h-25"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              showCharacterCount
              maxLength={MAX_NAME_LENGTH}
            />
          </FormItem>
        )}
      />
    </>
  )
}

export default RuleInstructionField
